import React from 'react';
import GenericTableFilter from '../../../../components/common/GenericTableFilter';
import { useLanguage } from '../../../../contexts/LanguageContext';

const CustomerDefinitionFilter = ({ handleApplyFilters, handleResetFilters }) => {
    const { th } = useLanguage();

    const filterFields = [
        { 
            field: 'Name', 
            headerName: th('customerDefinition.columnHeaders.firstName'), 
            type: 'text' 
        },
        { 
            field: 'Surname', 
            headerName: th('customerDefinition.columnHeaders.lastName'), 
            type: 'text' 
        },
        { 
            field: 'ChassisNo', 
            headerName: th('customerDefinition.columnHeaders.chassisNo'), 
            type: 'text' 
        }
    ];

    return (
        <div className="mb-2">
            <GenericTableFilter
                filterFields={filterFields}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
            />
        </div>
    );
};

export default CustomerDefinitionFilter; 